export { parseConfigValuesSerialized };
import { assert } from '../../utils.js';
import { parse } from '@brillout/json-serializer/parse';
function parseConfigValuesSerialized(configValuesSerialized) {
    const configValues = {};
    Object.entries(configValuesSerialized).forEach(([configName, configValueSeriliazed]) => {
        const { valueSerialized, definedAt } = configValueSeriliazed;
        assert(valueSerialized);
        assert(!configValues[configName]);
        configValues[configName] = {
            value: parse(valueSerialized),
            definedAt
        };
    });
    return configValues;
}
